import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useSearchParams
} from 'react-router-dom'
import { TourProvider } from '@reactour/tour'
import { Admin } from 'components/Admin'
import { isNil } from 'lodash/fp'
import { SnackbarProvider } from 'notistack'
import { useParams } from 'react-admin'

const Redirect: React.FC = () => {
  const { partner } = useParams()
  const [params] = useSearchParams()
  return isNil(params.get('cache_delete')) ? (
    <Navigate replace to={`/menu/${partner as string}?cache_delete=True`} />
  ) : (
    <Admin />
  )
}

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <SnackbarProvider maxSnack={1}>
        {!isNil(process.env['TOUR']) ? (
          <TourProvider steps={[]}>
            <Routes>
              <Route path="/menu/:partner" element={<Admin />} />
              <Route path="/*" element={<Admin />} />
              <Route path="/" element={<Admin />} />
            </Routes>
          </TourProvider>
        ) : (
          <Routes>
            <Route path="/menu/:partner" element={<Redirect />} />
            <Route path="/menu/:partner/*" element={<Admin />} />
            <Route path="/admin/:partner" element={<Admin admin />} />
            <Route path="/*" element={<Admin />} />
            <Route path="/" element={<Admin />} />
          </Routes>
        )}
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default App
